module.exports = __webpack_public_path__ + "static/media/icon.82eb2455.png";